export enum CONVERSATION_PAGE_ANCHOR {
  POSITIVE_THEME_SECTION = 'positive-theme-section',
  NEGATIVE_THEME_SECTION = 'negative-theme-section',
  BRANDS_PRODUCTS_SECTION = 'brands-products-section',
  WORD_CLOUD_SECTION = 'word-cloud-section',
}
